import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { SecondaryLink } from '@bibliocommons/base-links';
import { Table, TableHeader, TableHeading, TableBody, TableRow, TableCell } from 'app/components/shared/Table';

import ContextMenu from 'app/components/admin/browse/shared/ContextMenu';
import { listTitlesSectionShape, listTitlesSectionValidationShape } from 'app/shapes/admin/browse/home';
import EditorHasAlternativeBackgroundToggle from './shared/EditorHasAlternativeBackgroundToggle';
import EditorListUrl from './shared/EditorListUrl';
import TableWrapper from './shared/TableWrapper';

import './SectionEditorListTitles.scss';

const SectionEditorListTitles = ({ onChange, section: listTitlesSection, validation }) => {
  const { hasAlternativeBackground, listUrl, sectionId } = listTitlesSection;

  const { title = '', url = '' } = listUrl || {};

  const [isEditingUrl, setIsEditingUrl] = useState(!listUrl.url);

  useEffect(() => {
    setIsEditingUrl(!listUrl.url);
  }, [listUrl]);

  const handleHasAlternativeBackgroundChange = newHasAlternativeBackground => {
    onChange({
      ...listTitlesSection,
      hasAlternativeBackground: newHasAlternativeBackground
    });
  };

  const handleUrlEditCancel = () => {
    setIsEditingUrl(false);
  };

  const handleUrlEditClick = () => {
    setIsEditingUrl(true);
  };

  const handleUrlSave = newListUrl => {
    onChange({
      ...listTitlesSection,
      listUrl: newListUrl
    });
  };

  const editorHasAlternativeBackgroundToggleKey = `${sectionId}_EditorHasAlternativeBackgroundToggle`;
  const urlLinkKey = `${sectionId}_urlLink`;

  return (
    <div className="cp-admin-browse-home-section-editor-list-titles">
      <EditorHasAlternativeBackgroundToggle
        className="toggle-alt-background"
        key={editorHasAlternativeBackgroundToggleKey}
        onChange={handleHasAlternativeBackgroundChange}
        value={hasAlternativeBackground}
      />

      <TableWrapper>
        <Table>
          <TableHeader>
            <TableHeading>List title</TableHeading>
            <TableHeading colSpan={2}>List URL</TableHeading>
          </TableHeader>
          <TableBody>
            <TableRow>
              {isEditingUrl ? (
                <TableCell colSpan={3}>
                  <EditorListUrl
                    errorMessage={validation.errorByAttribute.listUrl}
                    onCancel={handleUrlEditCancel}
                    onChange={handleUrlSave}
                    listUrl={listUrl}
                  />
                </TableCell>
              ) : (
                <>
                  <TableCell>{title}</TableCell>
                  <TableCell>
                    <SecondaryLink dataKey={urlLinkKey} href={url} target="_blank">
                      {url}
                    </SecondaryLink>
                  </TableCell>
                  <TableCell className="cell-context-menu">
                    <ContextMenu onEditClick={handleUrlEditClick} />
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </TableWrapper>
    </div>
  );
};

SectionEditorListTitles.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      listUrl: ''
    }
  }
};

SectionEditorListTitles.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: listTitlesSectionShape.isRequired,
  validation: listTitlesSectionValidationShape
};

export default SectionEditorListTitles;
